import React from 'react';
import { ITableDataSource } from 'models/table';
import { colors } from 'theme/colors';
import Grid from '@mui/material/Grid';
import { Typography } from '@mui/material';
import Button from 'components/atoms/Button';
import { EButtonSizes, EButtonVariants } from 'constants/Buttons';
import { useTranslations } from 'hooks/useTranslations';
import { Chips } from 'components/atoms/Chips';
import { emptyFieldHolder } from 'components/molecules/CardList';
import { batchStatusVariant, EBatcheslabels } from '../../helpers';

interface IBatchTableCard {
  data: ITableDataSource;
  onClickDetails: (id: string) => void;
}

const BatchTableCard = ({ data, onClickDetails }: IBatchTableCard) => {
  const { t } = useTranslations();
  return (
    <Grid
      container
      sx={{
        border: `1px solid ${colors.gray200}`,
        borderRadius: '4px',
        overflow: 'hidden',
        mt: 1,
        backgroundColor: colors.gray100,
      }}
    >
      <Grid size={{ xs: 12, sm: 6 }} sx={{ px: 2, pt: 2 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('licences.batchName.label')}
        </Typography>
        <Typography variant="body2">{emptyFieldHolder(data.name)}</Typography>
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }} sx={{ px: 2, pt: 2 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t(EBatcheslabels.licenceAuthorityUniqueIds)}
        </Typography>
        <Typography variant="body2">{emptyFieldHolder(data.licencingAuthority)}</Typography>
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }} sx={{ px: 2, pt: 2 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t(EBatcheslabels.statusUniqueIds)}
        </Typography>
        <Chips text={data.status} variant={batchStatusVariant(data.statusUniqueId)} />
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }} sx={{ px: 2, pt: 2 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('licences.createDate.label')}
        </Typography>
        <Typography variant="body2">{emptyFieldHolder(data.createdDate)}</Typography>
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }} sx={{ px: 2, pt: 2 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('licences.manifestDate.label')}
        </Typography>
        <Typography variant="body2">{emptyFieldHolder(data.processedDate)}</Typography>
      </Grid>

      <Grid
        container
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          rowGap: 1,
          width: '100%',
          boxSizing: 'border-box',
          mt: 2,
          px: 2,
          py: 2,
          borderTop: `1px solid ${colors.primary100}`,
        }}
      >
        <Grid size={{ xs: 12, sm: 6 }}>
          <Typography variant="button" sx={{ textTransform: 'uppercase' }}>
            {t('licences.actions.label')}:{' '}
          </Typography>
        </Grid>
        <Grid
          size={{ xs: 12, sm: 6 }}
          sx={{ display: 'flex', justifyContent: 'right', alignItems: 'center' }}
        >
          <Button
            id={`batches_card_details-button-${data.id}`}
            variant={EButtonVariants.outlined}
            size={EButtonSizes.small}
            label={t('licences.details.label')}
            onClick={() => onClickDetails(data.id as string)}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default BatchTableCard;
